<kendo-textbox
  [readonly]="true"
  [value]="file ? file.name : displayValue ? displayValue : ''"
  [placeholder]="label"
>
  <ng-template kendoTextBoxSuffixTemplate>
    <div *ngIf="file">
      <button
        (click)="fileInput.click()"
        size="small"
        fillMode="clear"
        kendoButton
        icon="edit"
      ></button>
      <button
        (click)="clear()"
        size="small"
        fillMode="clear"
        kendoButton
        icon="delete"
      ></button>
    </div>

    <button
      *ngIf="!file"
      [primary]="true"
      (click)="fileInput.click()"
      class="mr-[0.1rem]"
      size="small"
      kendoButton
    >
      Избор на файл
    </button>
  </ng-template>
</kendo-textbox>
<input (change)="onFileChange($event)" #fileInput type="file" class="hidden" />
